import React, { useEffect } from 'react';
import { Layout } from 'tea-component';
import { useDispatch } from 'umi';
import 'tea-component/dist/tea.css';
import Wrapper from '@/pages/home/wrappers/common';

export default (props: any) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.location.pathname.toLowerCase().startsWith('/login')) {
      return;
    }
    // 用户信息
    dispatch({
      type: 'home/getUserInfo'
    });
    // 用户信息
    dispatch({
      type: 'home/getNavMenuList'
    });

    dispatch({
      type: 'home/getNavStudioList'
    });
  }, []);
  return (
    <Layout className="databrain-body">
      <Wrapper>{props.children}</Wrapper>
    </Layout>
  );
};
